<template>
    <div class="product-image-card">
        <img :src="image?.url || PLACEHOLDER_IMAGE_URL" class="product-image">
        <div class="image-actions">
            <button v-if="image?.url" type="button" @click="openImage" :title="$t('labels.open_image_in_new_tab')">
                <i class="icon-eye"></i>
            </button>
            <button type="button" @click="$refs.FileComponent.showFile()" :title="$t('buttons.upload')">
                <i class="icon-cloud-upload"></i>
            </button>
            <button v-if="image?.url" type="button" @click="removeImage" :title="$t('labels.remove_image')">
                <i class="icon-cross3"></i>
            </button>
        </div>
        <FileComponent ref="FileComponent" @fileIsSelected="selectFile" :accept="['image/*']" :multiple="false"/>
    </div>
</template>
<script>
import FileComponent from "../../../../../components/new/file/AppFile.vue";
import { PLACEHOLDER_IMAGE_URL } from "../../../../../constants";
import { httpClient } from "../../../../../services/HttpClient";

export default {
    name: "ProductImageCard",
    components: { FileComponent },
    props: {
        image: {
            type: [Object, null]
        },
        type: {
            type: String,
            required: true
        }
    },
    emits: ["update:image"],
    data() {
        return {
            PLACEHOLDER_IMAGE_URL
        }
    },
    methods: {
        openImage() {
            window.open(this.image.url, '_blank');
        },
        removeImage() {
            this.$emit('update:image', null);
        },
        selectFile(files) {
            let requestFile = new FormData();
            requestFile.append('file', files[0]);
            requestFile.append('type', this.type);

            httpClient.post('/file/files', requestFile).then((response) => {
                this.$emit('update:image', response.data.data);
            });
        }
    }
}
</script>
<style scoped>
.product-image-card {
    position: relative;
    width: 100%;
    height: 172px;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    overflow: hidden;
}
.product-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
    background-color: #f0f0f0;
    display: block;
}
.image-actions {
    position: absolute;
    top: 5px;
    right: 5px;
    display: flex;
    gap: 5px;
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
}
.product-image-card:hover .image-actions {
    opacity: 1;
}
.image-actions button {
    width: 24px;
    height: 24px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 255, 255, 0.8);
    border: none;
    border-radius: 50%;
    font-size: 12px;
}
.image-actions button:focus {
    outline: none;
}
</style>
